import {
  faCalendarAlt,
  faCheckCircle,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "@sbmdkl/nepali-datepicker-reactjs/dist/index.css";
import React, { Component } from "react";
import Spinner from "reactstrap/lib/Spinner";
import "../../assets/scss/admission.scss";
import { axiosPost } from "../../utils/AxiosApi";
import { URL } from "../../utils/Constants";
import { convertNepaliDate, emailValidate } from "../../utils/Utils";
import DatePicker from "../UI/DatePicker";
import NepaliDateViewer from "../UI/NepaliDateViewer";

import "nepali-datepicker-reactjs/dist/index.css";
import PhoneNumberInput from "../phoneNumberInput";
import { NepaliDatePicker } from "nepali-calander";
const { bsToAd } = require('@sbmdkl/nepali-date-converter');


class IdentityCluster extends Component {
  state = {
    customFields: [],
    genders: [],
    countrys: [],
  };

  componentDidMount() {
    this.getCustomFields();
    this.getGenders();
    this.getCountry();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.customTableFieldValuesByUsername !==
      this.props.customTableFieldValuesByUsername
    ) {
      this.getCustomFields();
    }
  }

  rereunSetter = () => {
    const customTableFieldValuesByUsername =
      this.props.customTableFieldValuesByUsername;
    let customFields = [...this.state.customFields];
    customFields.forEach((field) => {
      const valueField = customTableFieldValuesByUsername.find(
        (vf) => vf.customTableFieldId === field.id
      );
      field.value = valueField ? valueField.value : null;
    });
    this.setState({ customFields });
  };

  getCountry = () => {
    axiosPost(URL.getCountry, {}, (response) => {
      if (response.status === 200) {
        this.setState({ countrys: response.data.data });
      }
    });
  };

  getCustomFields = () => {
    axiosPost(
      URL.getIdentityCluster,
      {
        isConfig: this.props.config,
      },
      (response) => {
        if (response.status === 200) {
          let data = response.data.data;
          data.forEach((field) => {
            field.key = Math.random();
          });
          this.setState({ customFields: data }, () => {
            if (this.props.customTableFieldValuesByUsername) {
              this.rereunSetter();
            }
          });
        }
      }
    );
  };

  getGenders = () => {
    axiosPost(URL.getGenders, {}, (response) => {
      if (response.status === 200) {
        let data = response.data.data;
        this.setState({ genders: data });
      }
    });
  };

  showPreviousPhoto = (e) => { };

  handleNepaliDefaultValue = () => {
    if (this.props?.customTableField?.year?.toString() === "NaN") {
      return null
    }
    const newDate = `${this.props.customTableField.year}-${this.props.customTableField.month === 11 ||
      this.props.customTableField.month === 12 ||
      this.props.customTableField.month === 10
      ? this.props.customTableField.month
      : "0" + this.props.customTableField.month
      }-${this.props.customTableField.day}`;
    const dateValue = convertNepaliDate(newDate);
    return dateValue;
  };

  nepaliToEnglish = (nepaliDateStr) => {
    // Split the date string into its components
    const [year, month, day] = nepaliDateStr.split('-').map(Number);

    // Convert BS year to AD year (subtract 56)
    let englishYear = year - 56;

    // Handle month conversion
    let englishMonth;
    if (month > 9) {
      englishMonth = month - 3;
      englishYear += 1;  // Add 1 for next year
    } else {
      englishMonth = month + 9;
      if (englishMonth > 12) {
        englishMonth -= 12;
        englishYear += 1;  // Add 1 for next year
      }
    }

    // Format the result with leading zeros
    return `${englishYear}-${String(englishMonth).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  }

  render() {
    let studentFieldIndex = this.props.studentFieldIndex;
    let customTableFieldIndex = this.props.customTableFieldIndex;
    let stateName = this.props.stateName;
    const customTableField = this.props.customTableField;
    const customTableFieldValues =
      this.props.customTableField?.customTableFieldValues;
    return (
      <div className="card">
        <div className="card-body">
          <div className="tt-group-header">Identity Cluster</div>
          {!this.state.customFields ? (
            <div className="row mb-2">
              <div className="col-md-1"></div>
              <div className="col-md-3">
                <label>
                  <strong>Name </strong>
                  {this.props.inputForm && (
                    <span className="tt-assessment-module-mandatory">*</span>
                  )}
                </label>
              </div>
              <div className="col-md-7">
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="form-control"
                  maxLength={255}
                />
              </div>
              <div className="col-md-1"></div>
            </div>
          ) : null}
          {this.state.customFields
            ? this.state.customFields.map((fields, idx) => {
              const fieldName = fields.fieldName;
              return (
                <div key={fields.key} className="row mb-2">
                  <div className="col-md-1"></div>
                  <div className="col-md-2">
                    <label>
                      <strong>{fields.fieldName} </strong>
                      {this.props.inputForm && fields.isMandatory && (
                        <span className="tt-assessment-module-mandatory">
                          *
                        </span>
                      )}
                    </label>
                  </div>
                  <div className="col-md-8">
                    <input
                      type={fields.fieldTypeName}
                      name={fields.fieldName}
                      // value={fields.value}
                      value={
                        customTableField &&
                        customTableField[fields["fieldName"]]
                      }
                      defaultValue={
                        this.props.userFound
                          ? fields.value
                          : customTableFieldValues &&
                          customTableFieldValues.find(
                            (field) =>
                              field.customTableFieldId === fields.id
                          )?.value
                      }
                      maxLength={255}
                      onChange={
                        !this.props.config
                          ? (e) =>
                            this.props.handleCustomFieldChange(
                              e,
                              studentFieldIndex,
                              customTableFieldIndex,
                              stateName,
                              fields
                            )
                          : null
                      }
                      className={
                        customTableField?.error?.[fields.fieldName]
                          ? "form-control indicate-error"
                          : "form-control"
                      }
                    // className={
                    //   this.props.errors
                    //     ? stateName === "studentContactTableFieldGroups"
                    //       ? this.props.errors[stateName][studentFieldIndex]
                    //         ? this.props.errors[stateName][
                    //             studentFieldIndex
                    //           ][fields.fieldName]
                    //           ? "form-control indicate-error"
                    //           : fields.fieldTypeName === "file"
                    //           ? ""
                    //           : "form-control"
                    //         : this.props.errors[stateName][fields.fieldName]
                    //         ? "form-control indicate-error"
                    //         : "form-control"
                    //       : "form-control"
                    //     : "form-control"
                    // }
                    />
                    {(this.props?.module === "admission" || this.props?.module === "recruitment") && (
                      <>
                        {idx === 0 && (
                          <>
                            <span className={
                              (customTableField?.error?.[fields.fieldName] &&
                                !this.props?.customTableField['First Name']
                              )
                                ? "d-block text-danger"
                                : "d-none"
                            }>First name cannot be empty*</span>
                          </>
                        )}
                        {idx === 2 && (
                          <span className={
                            (customTableField?.error?.[fields.fieldName] &&
                              !this.props?.customTableField['Last Name']
                            )
                              ? "d-block text-danger"
                              : "d-none"
                          }>Last name cannot be empty*</span>
                        )}
                      </>
                    )}
                  </div>
                  {/* <div className="col-md-1">
                      {this.props.errors ? (
                        this.props.errors[stateName][fields.fieldName] ? (
                          <span className="customfield-error-text">
                            mandatory
                          </span>
                        ) : null
                      ) : null}
                    </div> */}
                </div>
              );
            })
            : null}
          <div className="row mb-2">
            <div className="col-md-1"></div>
            <div className="col-md-2">
              <label>
                <strong>Date of birth </strong>

                {this.props.inputForm && (
                  <span className="tt-assessment-module-mandatory">*</span>
                )}
              </label>
            </div>
            <div className={"col-md-4"}>
                <NepaliDatePicker
                  type="input"
                  calendarMode={localStorage.getItem('calendar-mode')}
                  showToggle={true}
                  showNationalHoliday={false}
                  events={[]}
                  onDateSelect={!this.props.config
                          ? (date) => {
                            this.props.handleBdayChange(
                              {
                               target: { value: date.ad.date } 
                              },
                              studentFieldIndex,
                              customTableFieldIndex,
                              stateName,
                            )
                          }
                          : null
                      }
                  value={
                    this.props.dateOfBirth
                  }
                /> 
              {(this.props?.module === "admission" || this.props?.module === "recruitment") && (
                <>
                  <span class={
                    ((this.props?.errors?.admissionTableFieldGroups?.day &&
                      this.props?.errors?.admissionTableFieldGroups?.month &&
                      this.props?.errors?.admissionTableFieldGroups?.year)
                      ||
                      (this.props?.errors?.customTableField?.day &&
                        this.props?.errors?.customTableField?.month &&
                        this.props?.errors?.customTableField?.year)
                    ) ? "text-danger d-block mb-1" : "d-none"
                  }>Date of birth cannot be empty*</span>
                </>
              )}
            </div>
            <div className="col-md-1">
              <label>
                <strong>Gender </strong>
                {this.props.inputForm && (
                  <span className="tt-assessment-module-mandatory">*</span>
                )}
              </label>
            </div>
            <div className="col-md-3">
              <select
                className={
                  this.props.errors
                    ? stateName === "admissionTableFieldGroups"
                      ? this.props.errors[stateName]
                        ? this.props.errors[stateName].gender
                          ? "form-control indicate-error"
                          : "form-control"
                        : this.props.errors[stateName][studentFieldIndex].gender
                          ? "form-control indicate-error"
                          : "form-control"
                      : this.props.errors[stateName][studentFieldIndex].gender
                        ? "form-control indicate-error"
                        : "form-control"
                    : "form-control"
                }
                name="gender"
                onChange={
                  !this.props.config
                    ? (e) =>
                      this.props.handleCustomFieldChange(
                        e,
                        studentFieldIndex,
                        customTableFieldIndex,
                        stateName
                      )
                    : null
                }
                value={customTableField && customTableField.gender}
              >
                {this.props.editMode ? null : (
                  <option value="" disabled selected>
                    Choose a gender
                  </option>
                )}
                {this.state.genders.map((gender) => (
                  <option value={gender.gender}>{gender.gender}</option>
                ))}
              </select>
              {(this.props?.module === "admission" || this.props?.module === "recruitment") && (
                <>
                  <span class={
                    (this.props?.errors?.admissionTableFieldGroups?.gender &&
                      !this.props?.customTableField['gender']
                    )
                      ? "text-danger d-block mb-1" : "d-none"
                  }> Gender cannot be empty*</span>
                </>
              )}
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-1"></div>
            <div className="col-md-2">
              <label>
                <strong>Nationality</strong>
                {this.props.inputForm && (
                  <span className="tt-assessment-module-mandatory">*</span>
                )}
              </label>
            </div>
            <div className="col-md-8">
              <select
                name="nationality"
                className={
                  this.props.errors
                    ? stateName === "admissionTableFieldGroups"
                      ? this.props.errors[stateName]
                        ? this.props.errors[stateName].nationality
                          ? "form-control indicate-error"
                          : "form-control"
                        : this.props.errors[stateName][studentFieldIndex]
                          .nationality
                          ? "form-control indicate-error"
                          : "form-control"
                      : this.props.errors[stateName][studentFieldIndex]
                        .nationality
                        ? "form-control indicate-error"
                        : "form-control"
                    : "form-control"
                }
                onChange={
                  !this.props.config
                    ? (e) =>
                      this.props.handleCustomFieldChange(
                        e,
                        this.props.studentFieldIndex,
                        this.props.customTableFieldIndex,
                        this.props.stateName
                      )
                    : null
                }
                value={customTableField && customTableField.nationality}
              >
                {this.props.editMode ? null : (
                  <option value="" selected disabled>
                    Choose a nationality
                  </option>
                )}
                {this.state.countrys.map((country, idx) => {
                  return (
                    <option key={idx} value={country.id}>
                      {country.nationality ? country.nationality : country.name}
                    </option>
                  );
                })}
              </select>
              {(this.props?.module === "admission" || this.props?.module === "recruitment") && (
                <>
                  <span class={
                    (this.props?.errors?.admissionTableFieldGroups?.nationality &&
                      !this.props?.customTableField['nationality']
                    )
                      ? "text-danger d-block mb-1" : "d-none"
                  }>Nationality cannot be empty*</span>
                </>
              )}
            </div>
            <div className="col-md-1"></div>
          </div>
          <div className="row mb-2">
            <div className="col-md-1"></div>
            <div className="col-md-2">
              <label>
                <strong>Photo: </strong>
              </label>
            </div>
            <div className="col-md-8">
              <input
                type="file"
                name="photo"
                accept="image/png, image/jpeg"
                onChange={
                  !this.props.config
                    ? (e) =>
                      this.props.handleFileChange(
                        e,
                        this.props.studentFieldIndex,
                        this.props.customTableFieldIndex,
                        this.props.stateName
                      )
                    : null
                }
                disabled={this.props.userFound && this.props.recruitmentImage}
              />
            </div>
            <div className="col-md-1"></div>
          </div>

          {/* {!this.props.student ? ( */}
          <div className="row mb-2">
            <div className="col-md-1"></div>
            <div className="col-md-2">
              <label>
                <strong>Email</strong>
                {/* {this.props.inputForm && (
                    <span className="tt-assessment-module-mandatory">*</span>
                  )} */}
              </label>
            </div>
            <div className="col-md-8">
              <input
                type="email"
                name="email"
                className=
                // "form-control"
                {(customTableField?.email && !emailValidate(customTableField?.email)) ? `form-control indicate-error` : `form-control`}
                // {
                //   this.props.errors
                //     ? stateName === "admissionTableFieldGroups"
                //       ? this.props.errors[stateName]
                //         ? this.props.errors[stateName].email
                //           ? "form-control indicate-error"
                //           : "form-control"
                //         : this.props.errors[stateName][studentFieldIndex]
                //           .email
                //           ? "form-control indicate-error"
                //           : "form-control"
                //       : this.props.errors[stateName][studentFieldIndex].email
                //         ? "form-control indicate-error"
                //         : "form-control"
                //     : "form-control"
                // }
                defaultValue={
                  stateName === "studentContactTableFieldGroups"
                    ? customTableField?.email
                    : this.props.email
                }
                value={customTableField?.email}
                onChange={
                  !this.props.config
                    ? (e) =>
                      this.props.handleCustomFieldChange(
                        e,
                        studentFieldIndex,
                        customTableFieldIndex,
                        stateName
                      )
                    : null
                }
              // onBlur={(e) =>
              //   this.props.checkIfEmailAvailable(e, customTableField.email)
              // }
              ></input>
              <span className={
                (customTableField?.email && !emailValidate(customTableField?.email)) ?
                  "d-block text-danger" :
                  "d-none"
              }>
                Email is invalid*
              </span>

            </div>
            <div className="col-md-1">
              {this.props.emailFetching ? (
                <Spinner color="primary" />
              ) : this.props.isEmailAvailable &&
                customTableField?.email &&
                customTableField?.email !== "" ? (
                <FontAwesomeIcon
                  icon={faCheckCircle}
                  className="primary-color username-icon"
                />
              ) : (
                this.props.isEmailAvailable === false &&
                customTableField?.email !== "" && (
                  <FontAwesomeIcon
                    icon={faTimesCircle}
                    id="incorrect"
                    className="danger-color username-icon"
                  />
                )
              )}
            </div>
          </div>
          {/* ) : null} */}

          <div className="row mb-2">
            <div className="col-md-1" />
            <div className="col-md-2">
              <div>
                <strong>Mobile number</strong>
              </div>
            </div>
            <div className="col-md-8">
              <PhoneNumberInput
                name="mobileNumber"
                className="form-control"
                value={customTableField?.mobileNumber}
                required={true}
                onChange={(e) =>
                  this.props.handleCustomFieldChange(
                    e,
                    studentFieldIndex,
                    customTableFieldIndex,
                    stateName,
                    {
                      fieldName: "mobileNumber",
                      mandatory: true,
                    }
                  )
                }
              />

              {/* <input
                type="number"
                name="mobileNumber"
                className="form-control"
                defaultValue={
                  stateName === "studentContactTableFieldGroups"
                    ? customTableField?.mobileNumber
                    : this.props.mobileNumber
                }
                value={customTableField?.mobileNumber}
                onChange={
                  !this.props.config
                    ? (e) =>
                      this.props.handleCustomFieldChange(
                        e,
                        studentFieldIndex,
                        customTableFieldIndex,
                        stateName
                      )
                    : null
                }
                onWheel={(e) => e.target.blur()}
              ></input> */}
            </div>
            <div className="col-md-1"></div>
          </div>
        </div>
      </div>
    );
  }
}

export default IdentityCluster;
